import React from 'react';
import { useSelector } from '../Redux/store';
const FullCoverLoading = React.memo(() => {
    const isLoading = useSelector(state => state.loading);
    return (React.createElement(React.Fragment, null, isLoading &&
        React.createElement("div", { className: "fixed w-full h-full z-999999 bg-gray-700 bg-opacity-40 flex flex-col items-center justify-center" })));
});
export default FullCoverLoading;
